import React from "react";
import { AlertTriangle, Calendar } from "lucide-react";
import { useDuplicateChalesAlerts } from "../hooks/useDuplicateChalesAlerts";

function DuplicateChalesAlert({ userRole, onSelectDate }) {
  const { conflicts, isLoading } = useDuplicateChalesAlerts(userRole);

  if (isLoading) return null;
  if (!conflicts || conflicts.length === 0) return null;

  return (
    <div className="mb-6 bg-red-50 dark:bg-red-950 border-l-4 border-red-500 rounded-r-lg p-4 shadow-sm animate-in fade-in slide-in-from-top-2">
      <div className="flex items-start">
        <div className="flex-shrink-0">
          <AlertTriangle className="h-6 w-6 text-red-600 dark:text-red-400" />
        </div>
        <div className="ml-3 w-full">
          <h3 className="text-sm font-bold text-red-800 dark:text-red-300">
            Atenção Crítica: {conflicts.length} conflito(s) de reserva de chalé detectado(s)!
          </h3>
          <div className="mt-2 text-sm text-red-700 dark:text-red-400">
            <p>O sistema identificou reservas com datas sobrepostas. Por favor, verifique imediatamente:</p>
            <ul className="mt-2 space-y-3">
              {conflicts.map((conflict, index) => {
                const { chaletNumber, res1, res2 } = conflict;
                // Consideramos a data de check-in da primeira reserva para ir corrigir
                const targetDate = res1.checkInDate;
                
                return (
                  <li 
                    key={index} 
                    className="flex flex-col bg-white dark:bg-slate-900 rounded-md p-3 border border-red-200 dark:border-red-900/50 shadow-sm"
                  >
                    <div className="flex justify-between items-center mb-2">
                      <span className="font-bold text-red-800 dark:text-red-300">
                        Chalé {chaletNumber < 10 ? `0${chaletNumber}` : chaletNumber}
                      </span>
                      <button
                        onClick={() => onSelectDate && onSelectDate(targetDate)}
                        className="flex items-center gap-1 text-xs bg-red-100 hover:bg-red-200 dark:bg-red-900/40 dark:hover:bg-red-900/60 text-red-700 dark:text-red-300 px-2 py-1 rounded transition-colors"
                      >
                        <Calendar className="h-3 w-3" />
                        Ir para a data
                      </button>
                    </div>
                    
                    <div className="text-xs space-y-1 text-slate-700 dark:text-slate-300">
                      <div className="flex items-center gap-2">
                        <span className="font-semibold w-16">Reserva A:</span> 
                        <span className="truncate flex-1">{res1.guestInfo}</span>
                        <span className="text-muted-foreground ml-auto shrink-0">
                          {res1.checkInDate.toLocaleDateString("pt-BR")} até {res1.checkOutDate.toLocaleDateString("pt-BR")}
                        </span>
                      </div>
                      <div className="flex items-center gap-2">
                        <span className="font-semibold w-16">Reserva B:</span> 
                        <span className="truncate flex-1">{res2.guestInfo}</span>
                        <span className="text-muted-foreground ml-auto shrink-0">
                          {res2.checkInDate.toLocaleDateString("pt-BR")} até {res2.checkOutDate.toLocaleDateString("pt-BR")}
                        </span>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DuplicateChalesAlert;
